// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"98ee7063","475":"01787487","607":"f7e9c929","637":"b288963f","688":"6116f864","706":"4fcff45a"}[chunkId] + ".chunk.js";
};